/**
 * 节目类
 */
export default class Program {
  constructor(program = {}) {
    this.programId = program.programId || 0; //节目编号
    this.programName = program.programName || ""; //节目名称
    this.programWidth = program.programWidth || 1920;
    this.programHeight = program.programHeight || 1080;
    this.groupId = program.groupId || ""; //所属工作组
    this.groupIdPath = program.groupIdPath || ""; //所属工作组path
    // this.orgId = program.orgId || -1; //所属组织编号
    this.shareProperty = program.shareProperty || "private"; //共享属性
    this.programRemarks = program.programRemarks || ""; //节目描述
    this.approveState = program.approveState || "approved"; //是否自动审核 approved\notApprove
    this.programType = program.programType || "normal"; //节目类型
    // this.programType = program.programType || "touch"; //节目类型
    this.autoSnap = program.autoSnap || true; //自动吸附
    this.rulerDisplay = program.rulerDisplay || 0; //标尺功能是否开启 0未开启，1标尺开启，但不开启标尺上的虚线，2标尺开启，并开启标尺上的虚线 3拖动时显示虚线
    this.lineDisplay = program.lineDisplay || 1; //对齐功能是否开启 0未开启，1开启不使用，2开启使用
    //this.pageList = program.pageList || []; //页面集合
    this.applicationType = program.applicationType || "normal";
    this.programScreenType = program.programScreenType || "single"; // 节目屏幕类型（单面屏or双面屏）
    this.firstScreen = program.firstScreen || {
      programId: 0, //主屏节目ID
      // templateId:0,//主屏选择的模板ID，给第一个page用（修改的时候好像拿不到）
      // applicationType:"",//主屏选择的模板applicationType，给第一个page用
      // pageList:[],//主屏页面信息
    };
    // 主屏副屏信息 屏幕类型为双面屏时才有副屏信息
    this.secondScreen = program.secondScreen || { programId: 0 };
    //联屏规格
    this.resolution = program.resolution;
    this.CascadeSize = program.CascadeSize;
    this.row = program.row
      ? program.row
      : program.CascadeSize
      ? program.CascadeSize.row
        ? program.CascadeSize.row
        : ""
      : "";
    this.column = program.column
      ? program.column
      : program.CascadeSize
      ? program.CascadeSize.column
        ? program.CascadeSize.column
        : ""
      : "";
    this.isSupportCasCadeResizeAndDrag = false;
    this.isSimpleProram = program.isSimpleProram || false; // (针对交互平板现在素材不全、只能插播做的标记）以后要拓展的话，这个字段写死为false就好
    this.programDeviceType = program.programDeviceType || "ad";
    this.selectedDeviceId = program.selectedDeviceId || "";
    this.AddAttribute = program.AddAttribute || {}; // 附加属性 目前用来存储led节目信号源的能力集
  }
}
